import styled from 'styled-components';
import { ReactComponent as UploadIcon } from './utils/Upload.svg';
import { ReactComponent as CameraIcon } from './utils/Camera.svg';
import { Typography } from '../Typography';
import { MEDIA_QUERY } from '../Theme';

export const DropzoneWrapper = styled.div`
  align-items: center;
  background-color: transparent;
  border-color: ${({ theme }) => `${theme.palette.button.border.select.base}`};
  border-radius: 8px;
  border-style: dashed;
  border-width: 1px;
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: column;
  outline: none;
  padding: 20px;
  transition: border 0.24s ease-in-out;
`;

export const UploadIconStyled = styled(UploadIcon)`
  fill: ${(p) => p.theme.palette.brand.color};
`;

export const CameraIconStyled = styled(CameraIcon)`
  cursor: pointer;
  fill: ${({ theme }) => theme.palette.brand.color};
  flex-grow: 4;
`;

export const DropzoneText = styled(Typography)`
  font-weight: bold;
  ${MEDIA_QUERY.below('sm')} {
    font-size: 1rem;
    margin: 0.5rem 0;
    text-align: center;
  }
`;
export const DropzoneAdditionalText = styled(Typography)`
  text-align: center;
  ${MEDIA_QUERY.below('sm')} {
    font-size: 0.75rem;
    margin: 0;
  }
`;
